import { useEffect } from 'react';
import { Modal, Spin } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Server } from '@wajeez-web/core/api-base';

import { CreateContentEntityBasicInfo } from './CreateContentEntityBasicInfo';
import {
  ContentEntityActions,
  getContentEntityItemDetailsByIdMultilingual,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { useAppDispatch } from '@wajeez-web/stores/base';
interface ContentEntityFormProps
  extends CommonModalProps<Server.ContentEntityTypeDetailedOutput> {
  loading?: boolean;
  data: Server.ContentEntityTypeDetailedOutput;
  id?: string;
}

const ContentEntityFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  loading,
  data,
  id,
}: ContentEntityFormProps) => {
  const dispatch = useAppDispatch();

  const itemDetailsByIdMultilingual = useContentSelector(
    (s) => s.contentEntity.itemDetailsByIdMultilingual
  );

  const sortedFields =
    data.fields?.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) ?? [];

  useEffect(() => {
    (async () => {
      if (id != undefined)
        await Promise.all([getContentEntityItemDetailsByIdMultilingual(id)]);
    })();
    return () => {
      dispatch(ContentEntityActions.clearItemDetailsByIdMultilingual());
    };
  }, [id]);

  return (
    <Modal
      loading={itemDetailsByIdMultilingual.status === 'loading'}
      title={data?.displayNameSingular || 'Content'}
      onClose={onClose}
      open={isOpen}
      withScroll={true}
      height={'auto'}
      width={
        (data?.requireText && data?.requireAudio) || data?.requireAudio
          ? 'screen'
          : undefined
      }
      fontClassName="font-[Tajawal]"
      alertTarget="modal"
    >
      <div>
        {itemDetailsByIdMultilingual.status === 'loading' ? (
          <div className="min-h-[300px] flex flex-col justify-center items-center">
            <Spin />
          </div>
        ) : (
          <CreateContentEntityBasicInfo
            type={data}
            onSubmit={(data) => {
              onSubmit && onSubmit(data);
            }}
            onCancel={onClose}
            isUpdating={loading}
            details={
              itemDetailsByIdMultilingual.data != undefined
                ? {
                    contentEntityTypeId: data.id ?? 0,
                    originalSubTitle:
                      itemDetailsByIdMultilingual.data?.originalSubTitle,
                    originalTitle:
                      itemDetailsByIdMultilingual.data?.originalTitle,
                    actualCost: itemDetailsByIdMultilingual.data?.actualCost,
                    actualDurationMS:
                      itemDetailsByIdMultilingual.data?.actualDurationMS,
                    profiles:
                      itemDetailsByIdMultilingual.data?.profiles?.map((p) => {
                        return {
                          ...p,
                          languageId: p.languageId ?? 0,
                          publishDate: p.publishDate,
                          title: p.title as string,
                          fields:
                            sortedFields?.map((f) => {
                              return {
                                ...f,
                                name: f.name as string,
                                value: p?.parameters?.find(
                                  (p) => p.key === f.name
                                )?.value,
                              };
                            }) ?? [],
                        };
                      }) ?? [],
                  }
                : undefined
            }
          />
        )}
      </div>
    </Modal>
  );
};

export default ContentEntityFormModal;
